import { useRouter } from 'next/router'
import { useEffect } from 'react';

export default function FoerderungkIndex({}) {
    const router = useRouter();

    useEffect(() => {
        router.push("/foerderung/foerderfinder");
    }, []);

    return (
        <></>
    )
}
